import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "No Data",
  "Choose current address",
  "Please enter the address"
];

export default createLegacyModule(keys);
